export default __webpack_public_path__ + "c43ac47fccf299850c1482cab9bea397.png";